// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Alerts Page - Beautiful Styles
   ============================================ */

.alerts-page {
  padding: 20px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
}

/* ============================================
   Alerts Grid
   ============================================ */

.alerts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 25px;
  padding: 10px 0;
}

/* ============================================
   Beautiful Alert Card
   ============================================ */

.alert-card-beautiful {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation: slideUpAlert 0.6s ease forwards;
  opacity: 0;
  transform: translateY(30px);
}

@keyframes slideUpAlert {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.alert-card-beautiful:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
}

/* Alert Card Header */
.alert-card-header {
  position: relative;
  padding: 30px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.alert-card-header::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 200%;
  background: rgba(255, 255, 255, 0.1);
  transform: rotate(30deg);
  pointer-events: none;
}

.alert-icon-wrapper {
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.alert-icon-wrapper i {
  font-size: 32px;
  color: white;
}

.alert-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 35px;
  height: 35px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulse 2s infinite;
}

.alert-badge i {
  font-size: 16px;
  color: white;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

/* Alert Card Body */
.alert-card-body {
  padding: 25px;
}

.alert-card-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.alert-card-message {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  margin: 0 0 20px 0;
}

/* Alert Card Footer */
.alert-card-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.alert-date-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #888;
  background: #f8f9fa;
  padding: 8px 12px;
  border-radius: 8px;
}

.alert-date-item i {
  font-size: 14px;
  color: #667eea;
}

/* ============================================
   Responsive Styles
   ============================================ */

@media (max-width: 767.98px) {
  .alerts-page {
    padding: 15px;
  }

  .alerts-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .alert-card-header {
    padding: 25px 15px;
  }

  .alert-icon-wrapper {
    width: 60px;
    height: 60px;
  }

  .alert-icon-wrapper i {
    font-size: 26px;
  }

  .alert-card-body {
    padding: 20px;
  }

  .alert-card-title {
    font-size: 16px;
  }

  .alert-card-message {
    font-size: 13px;
  }

  .alert-card-footer {
    flex-direction: column;
    gap: 10px;
  }

  .alert-date-item {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 575.98px) {
  .alerts-page {
    padding: 10px;
  }

  .alert-card-beautiful {
    border-radius: 15px;
  }

  .alert-card-header {
    padding: 20px;
  }

  .alert-icon-wrapper {
    width: 50px;
    height: 50px;
    border-radius: 15px;
  }

  .alert-icon-wrapper i {
    font-size: 22px;
  }

  .alert-badge {
    width: 30px;
    height: 30px;
    top: 10px;
    right: 10px;
  }

  .alert-badge i {
    font-size: 14px;
  }

  .alert-card-body {
    padding: 15px;
  }

  .alert-card-title {
    font-size: 15px;
  }

  .alert-card-message {
    font-size: 12px;
    margin-bottom: 15px;
  }

  .alert-date-item {
    font-size: 12px;
    padding: 6px 10px;
  }
}

/* ============================================
   Legacy Styles (kept for backwards compatibility)
   ============================================ */

.alerts-container {
  padding: 20px;
}

.alert-card {
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  font-family: Arial, sans-serif;
}

.alert-card:hover {
  transform: scale(1.02);
}

.alert-title {
  font-size: 1.2em;
  margin-bottom: 5px;
  font-weight: bold;
  color: #f0f0f0;
}

.alert-message {
  margin-bottom: 5px;
  color: #f0f0f0;
}

.alert-footer {
  font-size: 0.9em;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.alert-dates {
  font-size: 0.9em;
  color: #f0f0f0;
  display: flex;
  justify-content: space-between;
}

.alert-bg-light1 {
  background-color: #c2a3e7;
}

.alert-bg-light2 {
  background-color: #ea7cbe;
}

.alert-bg-light3 {
  background-color: #d6b23d;
}

.alert-bg-light4 {
  background-color: #88d148;
}`, "",{"version":3,"sources":["webpack://./src/views/dashboards/components/Alerts.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,4DAA4D;EAC5D,0CAA0C;EAC1C,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* ============================================\n   Alerts Page - Beautiful Styles\n   ============================================ */\n\n.alerts-page {\n  padding: 20px;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);\n}\n\n/* ============================================\n   Alerts Grid\n   ============================================ */\n\n.alerts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 25px;\n  padding: 10px 0;\n}\n\n/* ============================================\n   Beautiful Alert Card\n   ============================================ */\n\n.alert-card-beautiful {\n  background: white;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  animation: slideUpAlert 0.6s ease forwards;\n  opacity: 0;\n  transform: translateY(30px);\n}\n\n@keyframes slideUpAlert {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.alert-card-beautiful:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);\n}\n\n/* Alert Card Header */\n.alert-card-header {\n  position: relative;\n  padding: 30px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.alert-card-header::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -50%;\n  width: 100%;\n  height: 200%;\n  background: rgba(255, 255, 255, 0.1);\n  transform: rotate(30deg);\n  pointer-events: none;\n}\n\n.alert-icon-wrapper {\n  width: 70px;\n  height: 70px;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(10px);\n}\n\n.alert-icon-wrapper i {\n  font-size: 32px;\n  color: white;\n}\n\n.alert-badge {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  width: 35px;\n  height: 35px;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: pulse 2s infinite;\n}\n\n.alert-badge i {\n  font-size: 16px;\n  color: white;\n}\n\n@keyframes pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n}\n\n/* Alert Card Body */\n.alert-card-body {\n  padding: 25px;\n}\n\n.alert-card-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n  margin: 0 0 12px 0;\n  line-height: 1.4;\n}\n\n.alert-card-message {\n  font-size: 14px;\n  color: #666;\n  line-height: 1.7;\n  margin: 0 0 20px 0;\n}\n\n/* Alert Card Footer */\n.alert-card-footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n}\n\n.alert-date-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #888;\n  background: #f8f9fa;\n  padding: 8px 12px;\n  border-radius: 8px;\n}\n\n.alert-date-item i {\n  font-size: 14px;\n  color: #667eea;\n}\n\n/* ============================================\n   Responsive Styles\n   ============================================ */\n\n@media (max-width: 767.98px) {\n  .alerts-page {\n    padding: 15px;\n  }\n\n  .alerts-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .alert-card-header {\n    padding: 25px 15px;\n  }\n\n  .alert-icon-wrapper {\n    width: 60px;\n    height: 60px;\n  }\n\n  .alert-icon-wrapper i {\n    font-size: 26px;\n  }\n\n  .alert-card-body {\n    padding: 20px;\n  }\n\n  .alert-card-title {\n    font-size: 16px;\n  }\n\n  .alert-card-message {\n    font-size: 13px;\n  }\n\n  .alert-card-footer {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .alert-date-item {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .alerts-page {\n    padding: 10px;\n  }\n\n  .alert-card-beautiful {\n    border-radius: 15px;\n  }\n\n  .alert-card-header {\n    padding: 20px;\n  }\n\n  .alert-icon-wrapper {\n    width: 50px;\n    height: 50px;\n    border-radius: 15px;\n  }\n\n  .alert-icon-wrapper i {\n    font-size: 22px;\n  }\n\n  .alert-badge {\n    width: 30px;\n    height: 30px;\n    top: 10px;\n    right: 10px;\n  }\n\n  .alert-badge i {\n    font-size: 14px;\n  }\n\n  .alert-card-body {\n    padding: 15px;\n  }\n\n  .alert-card-title {\n    font-size: 15px;\n  }\n\n  .alert-card-message {\n    font-size: 12px;\n    margin-bottom: 15px;\n  }\n\n  .alert-date-item {\n    font-size: 12px;\n    padding: 6px 10px;\n  }\n}\n\n/* ============================================\n   Legacy Styles (kept for backwards compatibility)\n   ============================================ */\n\n.alerts-container {\n  padding: 20px;\n}\n\n.alert-card {\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 10px;\n  font-family: Arial, sans-serif;\n}\n\n.alert-card:hover {\n  transform: scale(1.02);\n}\n\n.alert-title {\n  font-size: 1.2em;\n  margin-bottom: 5px;\n  font-weight: bold;\n  color: #f0f0f0;\n}\n\n.alert-message {\n  margin-bottom: 5px;\n  color: #f0f0f0;\n}\n\n.alert-footer {\n  font-size: 0.9em;\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.alert-dates {\n  font-size: 0.9em;\n  color: #f0f0f0;\n  display: flex;\n  justify-content: space-between;\n}\n\n.alert-bg-light1 {\n  background-color: #c2a3e7;\n}\n\n.alert-bg-light2 {\n  background-color: #ea7cbe;\n}\n\n.alert-bg-light3 {\n  background-color: #d6b23d;\n}\n\n.alert-bg-light4 {\n  background-color: #88d148;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
